import Vue from 'vue';
import $d from '@/manage/utils/Data';

const $e = Vue.prototype.$eventHub;
const SYSTEMEVENTS = [
    'connect', // 连接成功
    'connectError', // 连接错误
    'error', // 请求错误
    'disconnect', // 连接异常中断
    'SocketError', // 连接请求错误
    'reconnect', // 重新连接成功
    'reconnectAttempt', // 尝试重新连接
    'reconnectError', // 重新连接错误
    'reconnectFailed' // 重新连接失败
];

SYSTEMEVENTS.forEach(eventName => {
    $e.$on(eventName, (data) => {
        console.log('eventName', eventName, data);
        $d.setSystemEvents([eventName, data]);
        $e.$emit('systemEvents', {
            errorName: eventName,
            errorData: data,
            errorList: $d.getSystemEvents()
        });
    });
});

$e.$on('data_visitorListError', (e) => {
    $e.$emit('visitorListError', e);
});
$e.$on('data_visitorListInit', (list) => {
    $e.$emit('visitorListInit', list);
});
$e.$on('data_visitorListUpdate', (list) => {
    $e.$emit('visitorListUpdate', list);
});
$e.$on('data_transferInfoChange', (transferInfo) => {
    $e.$emit('transferInfoChange', transferInfo);
});

$e.$on('data_historyError', (e) => {
    $e.$emit('historyError', e);
});
$e.$on('data_history', (msgList) => {
    $e.$emit('history', msgList);
});

$e.$on('data_transferInfoError', (e) => {
    $e.$emit('transferInfoError', e);
});
$e.$on('data_transferInfo', (transferInfo) => {
    $e.$emit('transferInfo', transferInfo);
});
$e.$on('data_session_reset', (data) => {
    $e.$emit('session_reset', data);
});

$e.$on('data_msgContentChange', (data) => {
    $e.$emit('msgContentChange', data);
});
$e.$on('data_currentVisitorChange', (info) => {
    $e.$emit('currentVisitorChange', info);
});

$e.$on('getHistoryMsg', () => {
    $d.getHistory();
});

$e.$on('getTransferHistoryMsg', () => {
    $d.getTransferHistory();
});

$e.$on('changeVisitor', (info) => {
    $d.setChatInfo(info);
});
$e.$on('data_referenceUpdate', (data) => {
    $e.$emit('referenceUpdate', data);
});
$e.$on('data_robotInfoChange', (data) => {
    $e.$emit('robotInfoChange', data);
});
$e.$on('data_robotError', () => {
    $e.$emit('robotError');
});

$e.$on('data_search', (data) => {
    $e.$emit('searchInfoChange', data);
});
$e.$on('data_searchError', (data) => {
    $e.$emit('searchError', data);
});
$e.$on('doSearch', (keywords) => {
    $d.handleSearch(keywords);
});
$e.$on('sendSearchMsg', () => {
    $d.sendSearchMsg();
});
$e.$on('searchMsg', () => {
    $d.handleSearch();
});

$e.$on('sendMsg', (msg) => {
    console.log('onsendMsg onsendMsg onsendMsg');
    $d.sendMsg(msg);
});
$e.$on('handleQuit', (msg) => {
    $d.handleQuit();
});

$e.$on('copySearchMsg', (msg) => {
    $d.handleCopySearchMsg();
});
$e.$on('data_answerCopySearchMsg', (data) => {
    $e.$emit('answerCopySearchMsg', data);
});

$e.$on('destroy', () => {
    $d.destroy();
});
$e.$on('renderReady', () => {
    $d.init();
});



// WEBPACK FOOTER //
// ./src/manage/eventsHandler.js